<template>
        <div class="w3-bar-block">
            <div v-if="!isOnline" class="w3-bar-item w3-button w3-hover-red w3-red ">
                <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon> OFFLINE ÁLLAPOT
            </div>          
            <router-link @click.native="$parent.updateViewKey()" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/intro">
                <font-awesome-icon icon="file-signature"></font-awesome-icon> BEMUTATKOZÁS
            </router-link>  
            <router-link @click.native="$parent.updateViewKey()" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/routes">
                <font-awesome-icon icon="route"></font-awesome-icon> ÚTVONALAK
            </router-link>    
            <router-link @click.native="$parent.updateViewKey()" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/promotions">
                <font-awesome-icon icon="font"></font-awesome-icon> AKTUÁLIS INFORMÁCIÓK
            </router-link>            
            <router-link @click.native="$parent.updateViewKey()" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/certifylist">
                <font-awesome-icon  icon="hiking"></font-awesome-icon> TELJESÍTÉSEK
            </router-link>               
            <router-link @click.native="$parent.updateViewKey()" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/contact">
                <font-awesome-icon icon="envelope"></font-awesome-icon> KAPCSOLAT
            </router-link>                           
            <router-link @click.native="$parent.updateViewKey()" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/info">
                <font-awesome-icon icon="info"></font-awesome-icon> TUDNIVALÓK
            </router-link>       
            <router-link @click.native="$parent.updateViewKey()" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/gyik">
                <font-awesome-icon icon="question-circle"></font-awesome-icon> GYIK
            </router-link>       
            <router-link @click.native="$parent.updateViewKey()" class="w3-bar-item w3-button w3-padding w3-hover-green"  :to="{ name: 'mainmap', params: { source: 'checkGPS' }}">
                <font-awesome-icon icon="map-marked-alt"></font-awesome-icon> HELYMEGHATÁROZÁS
            </router-link>       

            <router-link @click.native="$parent.updateViewKey()" v-if="!$store.getters.isLogin && !$store.getters.loginProcess && $store.getters.isProfileLoad" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/login/login">
                <font-awesome-icon icon="sign-in-alt"></font-awesome-icon> BEJELENTKEZÉS
            </router-link> 
            <router-link @click.native="$parent.updateViewKey()" v-if="!$store.getters.isLogin && !$store.getters.loginProcess && $store.getters.isProfileLoad" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/login/reg">
                <font-awesome-icon icon="address-card"></font-awesome-icon> REGISZTRÁCIÓ
            </router-link>                 
            <div v-if="$store.getters.loginProcess || !$store.getters.isProfileLoad" title='Bejelentkezés folyamatban' class="w3-bar-item w3-button w3-padding" >
                <font-awesome-icon icon="spinner" spin></font-awesome-icon> Bejelentkezés folyamatban...
            </div>  

            <div v-if="$store.getters.isLogin && $store.getters.isProfileLoad" class="w3-border-top">
                <!--<hr class="theme-1" style="height:2px;">-->          
                <router-link @click.native="$parent.updateViewKey()" v-if="isOnline" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/userdata">
                    <font-awesome-icon icon="user"></font-awesome-icon> ADATAIM
                </router-link>                 

                <router-link @click.native="$parent.updateViewKey()" v-if="isOnline" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/myentries">
                    <font-awesome-icon icon="clipboard"></font-awesome-icon> NEVEZÉSEIM
                </router-link>                 

                <router-link @click.native="$parent.updateViewKey()" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/favoritelist">
                    <font-awesome-icon icon="hiking"></font-awesome-icon> TELJESÍTÉSEIM
                </router-link>  

                <div v-on:click="logout()" class="w3-bar-item w3-button w3-padding w3-hover-green" >
                    <font-awesome-icon icon="sign-out-alt"></font-awesome-icon> KIJELENTKEZÉS
                </div>
            </div>
             <div v-if="$store.getters.isLogin && $store.getters.isProfileLoad && (isPaymentAdmin || isRouteAdmin)" class="w3-border-top">
                <!--<hr class="theme-1" style="height:2px;"> -->        
            
                <router-link @click.native="$parent.updateViewKey()" v-if="isOnline && isPaymentAdmin" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/paymentadmin">
                    <font-awesome-icon icon="euro-sign"></font-awesome-icon> FIZETÉSEK KEZELÉSE
                </router-link>  

                    
                <router-link @click.native="$parent.updateViewKey()" v-if="isOnline && isRouteAdmin" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/ownhikes">
                    <font-awesome-icon icon="edit"></font-awesome-icon> ÚTVONAL LÉTREHOZÁS
                </router-link>   
                <router-link @click.native="$parent.updateViewKey()" v-if="isOnline && isModeratorAdmin" class="w3-bar-item w3-button w3-padding w3-hover-green"  to="/moderator">
                    <font-awesome-icon icon="check"></font-awesome-icon> MODERÁLÁS
                </router-link>          
            </div>

              
        </div>
</template>
                

            
<script>
const fb = require('../firebase.js');
export default {
    name: 'Menu',
    data() {
        return {
        }
    },
    methods:{
        logout(){
            var uploadCertifyList = this.$storage.get('uploadCertifyList', []);
            if (uploadCertifyList.length>0) {
                let self=this;
                this.$dialog.confirm(this.$setDialogMsg('w3-yellow','Kijelentkezés','Fel nem töltött teljesítések vannak az adatbázisban. Ha kijelentkezel, ezek az adatok elvesznek. Biztosan kijelentkezel?'))
                .then(function(dialog) {
                    this.signOut();
                });  
            } else {
                this.signOut();
            }
        },
        signOut(){
            this.$storage.set('isLoginProcess', false);  
            fb.SignOut().then(res=>{
                this.$storage.set('favoriteList', []);
                this.$storage.set('uploadCertifyList', []);
                this.$router.push('/');
            }).catch(e=>{
                console.log(e);
                this.$dialog.alert(this.$setDialogMsg('w3-red','Kijelentkezés','Hiba történt a kijelentkezés során.'));         

            })            
        },                 
    },
    computed: {
        isPaymentAdmin: function () {
            if (this.$store.getters.userProfile) {
                return fb.IsPaymentAdmin(this.$store.getters.userProfile.uid);
            } else {
                return false;
            }
        },
        isRouteAdmin: function () {
            if (this.$store.getters.userProfile) {
                return fb.IsRouteAdmin(this.$store.getters.userProfile.uid);
            } else {
                return false;
            }
        },
        isModeratorAdmin: function () {
            if (this.$store.getters.userProfile) {
                return fb.IsModeratorAdmin(this.$store.getters.userProfile.uid);
            } else {
                return false;
            }
        }          
    }, 
    mounted: function(){
        
    }

}
</script>


            